<template>
  <el-checkbox-button v-bind="$attrs"> <slot /> </el-checkbox-button>
</template>

<script>
export default {
  name: 'RtCheckboxButton'
};
</script>

<style></style>



// WEBPACK FOOTER //
// rtCheckboxButton.vue?81a824aa